import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";
import Designer from "../Designer";
import { track } from "../../lib/analytics";
import { FONT, useSeo } from "./Marketing";

export default function Demo() {
  useSeo("Live Demo — Try The AI Turf Designer Free", "Try the AI Turf Designer live in your browser — design custom gym turf, generate AI concepts and see an instant price. No signup required.");
  const nav = useNavigate();
  const goTrial = () => { track("signup_clicked", { source: "demo-bar" }); nav("/signup?source=demo"); };
  return (
    <div className="h-screen flex flex-col bg-[#0a0a0a]" data-testid="demo-page">
      <div className="shrink-0 flex items-center justify-between gap-3 px-4 md:px-6 h-14 border-b border-white/10 bg-[#0d0d0d]">
        <div className="flex items-center gap-3 min-w-0">
          <Link to="/software" className="text-zinc-400 hover:text-white flex items-center gap-1.5 text-sm shrink-0" data-testid="demo-back"><ArrowLeft size={16} /><span className="hidden sm:inline">Back</span></Link>
          <span className="hidden md:inline-flex items-center gap-1.5 text-[11px] uppercase tracking-widest text-[#00D26A] bg-[#00D26A]/10 border border-[#00D26A]/30 rounded-full px-3 py-1">
            <Sparkles size={12} /> Live Demo · 2 free AI generations
          </span>
          <span className="text-white font-black uppercase tracking-tight truncate" style={{ fontFamily: FONT.display }}>AI Turf Designer</span>
        </div>
        <button onClick={goTrial} data-testid="demo-bar-trial" className="shrink-0 bg-[#00D26A] text-black font-bold uppercase tracking-widest text-[11px] md:text-xs px-4 md:px-6 py-2.5 rounded-md hover:bg-[#00E574] transition-colors">Start 14-Day Free Trial</button>
      </div>
      <div className="flex-1 min-h-0">
        <Designer demo />
      </div>
    </div>
  );
}
